module.exports = __webpack_public_path__ + "img/opticien.5be34df0.png";